// to ensure safety when accessing prototype methods on objects
// https://eslint.org/docs/latest/rules/no-prototype-builtins
export const hasOwnProp = (obj: any, prop: string) =>
  obj ? Object.prototype.hasOwnProperty.call(obj, prop) : false
